import { resolveSuggestionKind } from './kindLabel'
import type { AddressSuggestion, FiasSuggestionDto } from './types'

function toOptionalNumber(value: unknown): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined
}

/**
 * Интерцептор `clearResponseData` разворачивает `{ data: [...] }` в массив,
 * поэтому маппер принимает и конверт, и уже развёрнутый список.
 */
export function mapSuggestions(payload: unknown): AddressSuggestion[] {
  const list = Array.isArray(payload) ? payload : ((payload as { data?: unknown })?.data ?? null)

  if (!Array.isArray(list)) return []

  return list.reduce<AddressSuggestion[]>((acc, raw, index) => {
    const item = raw as FiasSuggestionDto
    const title = typeof item?.title === 'string' ? item.title.trim() : ''
    if (!title) return acc

    acc.push({
      id: item.id || `${title}-${index}`,
      title,
      kind: resolveSuggestionKind(item.kind, item.level),
      fullAddress: typeof item.full_address === 'string' ? item.full_address : title,
      level: toOptionalNumber(item.level),
      objectId: toOptionalNumber(item.object_id),
      parentId: toOptionalNumber(item.parent_id),
    })

    return acc
  }, [])
}
